import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { WorldScene } from './scenes/WorldScene';
import { HudScene } from './scenes/HudScene';

export const GAME_WIDTH = 960;
export const GAME_HEIGHT = 540;

export function createGameConfig(parent: string): Phaser.Types.Core.GameConfig {
  return {
    type: Phaser.AUTO,
    parent,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    backgroundColor: '#0f3d1f',
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    // WorldScene renders the CP21 side-scroller world; HudScene is launched
    // alongside it (not started in place of it) for the fixed-overlay HUD
    // (split bar, quota, prompts) - Phaser's standard parallel-scene HUD
    // pattern. See BootScene.create().
    scene: [BootScene, WorldScene, HudScene],
  };
}
